module.exports = __webpack_public_path__ + "img/thumbnail_EuropeanBadger_m_albino.61c5f18f.png";